import useApi from '../../hooks/api/useApi';
import useMutate from '../../hooks/api/useMutate';

export function useGetPlans() {
  const { data, error, isLoading, refresh } = useApi('/plans', {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    revalidateIfStale: false
  });

  return {
    plans: data?.data?.plans || [],
    currentPlanId: data?.data?.current_plan_id ?? null,
    currentBillingCycle: data?.data?.current_billing_cycle ?? null,
    currentEndDate: data?.data?.current_end_date ?? null,
    success: data?.success ?? false,
    error,
    isLoading,
    refresh
  };
}

export function useInitiateLocationAddon() {
  const { post, isMutating } = useMutate('/payment/initiate/location-addon');

  const initiateLocationAddon = async ({ merchant_id, billing_cycle = 'monthly' }) => {
    const res = await post({ merchant_id, billing_cycle });
    return { gateway: res?.gateway, ...(res?.data ?? {}) };
  };

  return { initiateLocationAddon, isMutating };
}
